import LoadingButton from '@mui/lab/LoadingButton';
import React from 'react';
import { Form } from 'react-final-form';
import { Stack, Unstable_Grid2 as Grid } from '@mui/material';

import { Button, KeyboardDateTimePicker, Select, Typography } from '@occc-app/design-system';
import { Allowed_List_Phone_Number_Time_Period } from '@occc/graphql';

import {
  AllowListPhoneNumberFilterFormValues,
  AllowListPhoneNumberFilterInitialFormValues,
} from './table-filter.types';
import { AllowListPhoneNumberFilterValidation } from './table-filter.validation';
import { enteredOnOptions } from './table-filter.constants';

type TableFilterContainerProps = {
  onSubmit(values: AllowListPhoneNumberFilterFormValues): void;
  onReset(): void;
  initialValues: AllowListPhoneNumberFilterInitialFormValues;
};

export const TableFilterContainer = ({
  onSubmit,
  onReset,
  initialValues,
}: TableFilterContainerProps) => {
  return (
    <Stack gap={3} p={3}>
      <Typography variant={'h6'}>Filter Phone Numbers</Typography>
      <Form<AllowListPhoneNumberFilterFormValues>
        onSubmit={onSubmit}
        initialValues={initialValues}
        validate={AllowListPhoneNumberFilterValidation}
        render={(props) => {
          return (
            <form onSubmit={props.handleSubmit}>
              <Grid container spacing={3}>
                <Grid xs={12}>
                  <Select
                    name={'period' satisfies keyof AllowListPhoneNumberFilterFormValues}
                    label='Entered On'
                    data={enteredOnOptions}
                    formControlProps={{ size: 'medium', margin: 'none' }}
                  />
                </Grid>

                <Grid xs={12} sm={6}>
                  <KeyboardDateTimePicker
                    label='Start Date'
                    name={'startDate' satisfies keyof AllowListPhoneNumberFilterFormValues}
                    disabled={props.values.period !== Allowed_List_Phone_Number_Time_Period.Custom}
                  />
                </Grid>

                <Grid xs={12} sm={6}>
                  <KeyboardDateTimePicker
                    label='End Date'
                    name={'endDate' satisfies keyof AllowListPhoneNumberFilterFormValues}
                    disabled={props.values.period !== Allowed_List_Phone_Number_Time_Period.Custom}
                  />
                </Grid>

                <Grid xs={12}>
                  <Stack direction='row' spacing={2} justifyContent='flex-end'>
                    <Button variant='text' onClick={onReset}>
                      Reset
                    </Button>

                    <LoadingButton
                      loading={props.submitting}
                      variant='contained'
                      type='submit'
                      disabled={props.submitting || props.hasValidationErrors || props.pristine}
                    >
                      Apply
                    </LoadingButton>
                  </Stack>
                </Grid>
              </Grid>
            </form>
          );
        }}
      />
    </Stack>
  );
};
